import { useApi } from "./api-service";
import {
  ConnectionResponse,
  SpotOnOAuthResponse,
  SpotOnLocationsResponse,
  SpotOnLocationsUpdateRequest,
} from "../../types/api/connections";

export function useConnectionsService() {
  const agentRequired = false;
  const connectionsApi = useApi(agentRequired);

  return {
    fetchSpotOnConnections: async (): Promise<ConnectionResponse[]> => {
      return connectionsApi.get<ConnectionResponse[]>("/connect/connections");
    },

    startSpotOnOAuth: async (): Promise<string> => {
      const response =
        await connectionsApi.get<SpotOnOAuthResponse>("/connect/spoton");
      return response.redirectUrl;
    },

    fetchSpotOnLocations: async (): Promise<SpotOnLocationsResponse> => {
      return connectionsApi.get<SpotOnLocationsResponse>(
        "/connect/spoton/locations"
      );
    },

    updateSpotOnLocations: async (
      locations: SpotOnLocationsUpdateRequest
    ): Promise<void> => {
      return connectionsApi.put<void>("/connect/spoton/locations", locations);
    },

    deleteSpotOnConnection: async (): Promise<void> => {
      return connectionsApi.delete<void>("/connect/spoton");
    },

    startStreamOAuth: async (): Promise<string> => {
      const response = await connectionsApi.get<{ redirectUrl: string }>(
        "/connect/stream"
      );
      return response.redirectUrl;
    },
  };
}
